import * as api from 'assets/js/api';

const state = {
  license: null,
};

const actions = {
  GetLicense({ commit, stateArg }, payload) {
    if (!payload.force && stateArg && stateArg.license) {
      return new Promise((resolve) => { resolve(); });
    }

    return api.Get(api.urls.LICENSE).then((response) => {
      commit('SET_LICENSE', response.data);
    }).catch((err) => {
      commit('SET_ERROR',
        `There was an error retrieving the license: ${err}`);
      throw err;
    });
  },
};

const mutations = {
  SET_LICENSE(stateArg, license) {
    const stateCopy = stateArg;
    stateCopy.license = license;
  },
};

export default { actions, mutations, state };
